import { render, staticRenderFns } from "./DesignerAvgData.vue?vue&type=template&id=363a2b12&scoped=true"
import script from "./DesignerAvgData.vue?vue&type=script&lang=js"
export * from "./DesignerAvgData.vue?vue&type=script&lang=js"
import style0 from "./DesignerAvgData.vue?vue&type=style&index=0&id=363a2b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a2b12",
  null
  
)

export default component.exports